import { useEffect, useRef } from "react";
import { matchPath, useLocation } from "react-router-dom";

const JOURNEY_URL = "https://admuserjourney.api.adsctv.net/apps/log";
const TOKEN_KEY = "qrt_token";

const PAGES = [
  { route: "/qrs", name: "qr_list" },
  { route: "/qrs/:id", name: "qr_detail" },
  { route: "/users", name: "users" },
];

export default function JourneyTracker() {
  const { pathname } = useLocation();
  const last = useRef("");

  useEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;

    const page = PAGES.find((p) => matchPath(p.route, pathname));
    let token = null;
    try {
      token = localStorage.getItem(TOKEN_KEY);
    } catch {
      return;
    }
    if (!page || !token) return;

    fetch(JOURNEY_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Token: token },
      body: JSON.stringify({
        page: page.name,
        route: page.route,
        action_type: "page_view",
        platform: "web",
      }),
      keepalive: true,
    }).catch(() => {});
  }, [pathname]);

  return null;
}
